<template>
  <div>
    <div v-if="progressOnly">
      <div class="text-dark-gray text-14 text-left font-bold w-full">
        Showing {{ start }}-{{ Math.min(pagination.total, end) }} of {{ pagination.total }}
      </div>
    </div>

    <div v-else>
      <div v-if="query.search" class="text-dark-gray text-14 text-left font-bold w-full">
        Showing results for <span class="text-black">"{{ query.search }}"</span>
      </div>

      <div v-else class="text-dark-gray text-14 text-left font-bold w-full">
        Showing {{ start }}-{{ Math.min(pagination.total, end) }} of {{ pagination.total }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['query'],

  props: {
    pagination: { required: true, type: Object },
    progressOnly: { type: Boolean }
  },

  computed: {

    start () {
      return (this.end - this.pagination.per_page) + 1
    },

    end () {
      return this.pagination.current_page * this.pagination.per_page
    },
  },
}
</script>
